import { ConfirmationModal, Typography } from 'seagull';
import RecipientDetails from "../../RecipientDetails/RecipientDetails";
import styles from "./ReadyToSendModal.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ReadyToSendModal(props) {
  const {
    firstName,
    lastName,
    email,
    companyName,
    reviewers,
    dismissModal
  } = props;
  const effectiveReviewers = reviewers.filter(reviewer => reviewer.firstName && reviewer.lastName && reviewer.email);
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    title: "Ready to send?",
    "data-testid": "send-proposal-modal",
    width: "700px",
    content: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(Typography, {
        weight: "normal",
        children: "You're about to send this proposal to:"
      }), /*#__PURE__*/_jsx(RecipientDetails, {
        testid: "primary-recipient",
        firstName: firstName,
        lastName: lastName,
        email: email,
        companyName: companyName,
        badge: effectiveReviewers.length > 0 ? 'required' : undefined
      }), effectiveReviewers.length > 0 && /*#__PURE__*/_jsxs("div", {
        className: styles.additionalRecipients,
        children: [/*#__PURE__*/_jsx(Typography, {
          weight: "normal",
          children: "Additional recipients"
        }), effectiveReviewers.map((reviewer, idx) => {
          return reviewer.firstName && reviewer.lastName && reviewer.email && /*#__PURE__*/_jsx(RecipientDetails, {
            testid: "additional-recipient-".concat(idx),
            firstName: reviewer.firstName,
            lastName: reviewer.lastName,
            email: reviewer.email,
            badge: reviewer.isSignatory ? 'required' : undefined
          }, idx);
        })]
      })]
    }),
    textAlignCenter: false,
    onPrimaryButtonClick: () => dismissModal(true),
    onSecondaryButtonClick: () => dismissModal(false),
    primaryButtonLabel: "Send now",
    secondaryButtonLabel: "Back"
  });
}